import { lazy } from 'react';
import { AppRoute } from './route.types';
import { ROLE_MAPS } from '@shared/constants/roles';
import { PLAN_MAPS } from '@shared/constants/plans';
import { Loadable } from '@components/lazy-load/loadable';
const LogoutAndRedirect = Loadable(lazy(() => import('@modules/auth/common/logout-and-redirect')));
const DialerPage = Loadable(lazy(() => import('@modules/dialer-extension.page')));
const NumberReport = Loadable(lazy(() => import('@modules/analytics/number-report/number-report.page')));
const MyAccountPage = Loadable(lazy(() => import('@modules/my-account/my-account-page')));
const NumberReportDetail = Loadable(
  lazy(() => import('@modules/analytics/number-report-detail/number-report-detail.page'))
);
const MemberReport = Loadable(lazy(() => import('@modules/analytics/member-report/member-report.page')));
const MemberReportDetail = Loadable(
  lazy(() => import('@modules/analytics/member-report-detail/member-report-detail.page'))
);
const AiDashboard = Loadable(lazy(() => import('@modules/analytics/ai-dashboard/ai-dashboard.page')));
const AdvancedReport = Loadable(lazy(() => import('@modules/analytics/advanced-report/advanced-report.page')));
const MyNumberSettings = Loadable(lazy(() => import('@modules/settings/my-numbers/my-numbers.page')));
const CallerIDSettings = Loadable(lazy(() => import('@modules/settings/caller-id/caller-id.page')));
const PurchaseNumberSettings = Loadable(
  lazy(() => import('@modules/settings/my-numbers/purchase-number/purchase-number.page'))
);
const MembersSettings = Loadable(lazy(() => import('@modules/settings/members/members.page')));
const TeamManagementSettings = Loadable(lazy(() => import('@modules/settings/team-management/team-management.page')));
const TeamDetailSettings = Loadable(lazy(() => import('@modules/settings/team-detail/team-detail.page')));
const BlockListPage = Loadable(lazy(() => import('@modules/settings/block-list/block-list.page')));
const SavedReplies = Loadable(lazy(() => import('@modules/settings/saved-replies/saved-replies.page')));
const SubscriptionPage = Loadable(lazy(() => import('@modules/settings/subscription/subscription.page')));
const MyMfaPage = Loadable(lazy(() => import('@modules/my-account/features/my-mfa/my-mfa.page')));
const MyMfaVerifyPage = Loadable(lazy(() => import('@modules/my-account/features/my-mfa/my-mfa-verify.page')));

const OrderAndInvoicesPage = Loadable(
  lazy(() => import('@modules/settings/order-and-invoices/order.and.invoices.page'))
);
const ReasonForCalls = Loadable(lazy(() => import('@modules/analytics/reason-for-calls/reason-for-calls.page')));
const PositiveSentimentReport = Loadable(
  lazy(() => import('@modules/analytics/positive-sentiment-report/positive-sentiment-report.page'))
);
const NegativeSentimentReport = Loadable(
  lazy(() => import('@modules/analytics/negative-sentiment-report/negative-sentiment-report.page'))
);
const Wallet = Loadable(lazy(() => import('@modules/settings/wallet/wallet.page')));
const ConclusionForCalls = Loadable(
  lazy(() => import('@modules/analytics/conclusions-for-calls/conclusion-for-calls.page'))
);
const CallResolution = Loadable(lazy(() => import('@modules/analytics/call-resolution/call-resolution.page')));
const DashboardPage = Loadable(lazy(() => import('@modules/dashboard/dashboard.page')));
const ConversationPage = Loadable(lazy(() => import('@modules/conversations/conversation.page')));
const ConversationRedirection = Loadable(lazy(() => import('@modules/conversations/conversation-redirection.page')));
const PaymentMethodsPage = Loadable(lazy(() => import('@modules/settings/payment-methods/payment-methods.page')));
const ContactsPage = Loadable(lazy(() => import('@modules/contacts/contacts.page')));
const MessagingConsentPage = Loadable(lazy(() => import('@modules/consents/messaging-consents.page')));
const BulkMessagingPage = Loadable(lazy(() => import('@modules/bulk-messaging/bulk-messaging.page')));
const ComposeMessagePage = Loadable(
  lazy(() => import('@modules/bulk-messaging/bulk-sms-message/compose-message/compose-message.page'))
);
const EditMessagePage = Loadable(lazy(() => import('@modules/bulk-messaging/components/edit-message.page')));
const BulkMessageReportPage = Loadable(
  lazy(() => import('@modules/bulk-messaging/bulk-message-report/bulk-message-report.page'))
);
const BulkMessageRunReportPage = Loadable(
  lazy(() => import('@modules/bulk-messaging/bulk-message-report/bulk-message-run-report.page'))
);
const RecurringCampaignPage = Loadable(
  lazy(() => import('@modules/bulk-messaging/recurring-campaign/recurring-campaign.page'))
);
const SupportTicket = Loadable(lazy(() => import('@modules/support-ticket.page')));
const RootRedirect = Loadable(lazy(() => import('@modules/auth/common/root-redirect')));
const NewConversationPage = Loadable(lazy(() => import('@modules/conversations/new-conversation.page')));
const MemberConversationPage = Loadable(
  lazy(() => import('@modules/conversations/features/member-conversation/member-conversation.page'))
);
const Integrations = Loadable(lazy(() => import('@modules/settings/integrations/integrations.page')));
const IntegrationDetails = Loadable(
  lazy(() => import('@modules/settings/integrations/components/integration-details.page'))
);
const WorkspacePage = Loadable(lazy(() => import('@modules/settings/workspace/workspace.page')));

const NumberGroups = Loadable(lazy(() => import('@modules/settings/number-groups/number-groups.page')));
const PaymentRequestPage = Loadable(lazy(() => import('@modules/settings/order-and-invoices/payment-request.page')));

// NEW NUMBER SETTINGS PAGE
const CallFlowsList = Loadable(lazy(() => import('@modules/settings/call-settings-list/call-settings-list')));
const NumberSettingsPage = Loadable(lazy(() => import('@modules/settings/call-settings/number-settings.page')));
const CallSettingsPage = Loadable(lazy(() => import('@modules/settings/call-settings/call-settings.page')));
const BusinessHoursSettingsV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/business-hours/business-hours.page'))
);
const AfterHoursSettingsV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/after-hours/after-hours.page'))
);
const GreetingMessagePageV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/greeting-message/greeting-message.page'))
);
const IVRSettingsV2 = Loadable(lazy(() => import('@modules/settings/call-settings/features/ivr/ivr.page')));
const CallForwardingV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/call-forwarding/call-forwarding.page'))
);
const VoicemailV2 = Loadable(lazy(() => import('@modules/settings/call-settings/features/voicemail/voicemail.page')));
const CustomCallerTuneV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/custom-caller-tune/caller-tune.page'))
);
const AutoRecordCallsV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/auto-record/auto-record.page'))
);
const CallTransferV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/call-transfer/call-transfer.page'))
);
const EmailNotificationAlertV2 = Loadable(
  lazy(() => import('@modules/settings/call-settings/features/email-notification-alert/email-notification-alert.page'))
);
const AppRedirectCenter = Loadable(lazy(() => import('@modules/app-redirection-center/app-redirection-center.page')));

const analytics: AppRoute[] = [
  {
    type: 'parent',
    path: '/analytics',
    children: [
      {
        type: 'parent',
        path: '/number-report',
        children: [
          {
            type: 'render',
            path: '/',
            component: NumberReport,
            breadcrumbs: [
              {
                title: 'Analytics',
              },
              {
                title: 'Number Report',
              },
            ],
          },
          {
            type: 'render',
            path: '/:channelId',
            component: NumberReportDetail,
            breadcrumbs: [
              {
                title: 'Analytics',
              },
              {
                title: 'Number Report',
                link: '/analytics/number-report',
              },
              {
                title: ':numberName',
              },
            ],
          },
        ],
      },
      {
        type: 'parent',
        path: '/member-report',
        children: [
          {
            type: 'render',
            path: '/',
            component: MemberReport,
            breadcrumbs: [
              {
                title: 'Analytics',
              },
              {
                title: 'Member Report',
              },
            ],
          },
          {
            type: 'render',
            path: '/:memberId',
            component: MemberReportDetail,
            breadcrumbs: [
              {
                title: 'Analytics',
              },
              {
                title: 'Member Report',
                link: '/analytics/member-report',
              },
              {
                title: ':memberName',
              },
            ],
          },
        ],
      },

      {
        type: 'parent',
        path: '/ai-dashboard',
        children: [
          {
            type: 'render',
            path: '/',
            component: AiDashboard,
            breadcrumbs: [
              {
                title: 'Analytics',
              },
              {
                title: 'AI Dashboard',
              },
            ],
          },
        ],
      },

      {
        type: 'render',
        path: '/advanced-report',
        component: AdvancedReport,
        breadcrumbs: [
          {
            title: 'Analytics',
          },
          {
            title: 'Advanced Report',
          },
        ],
      },

      {
        type: 'parent',
        path: '/reason-for-calls',
        children: [
          {
            type: 'render',
            path: '/',
            component: ReasonForCalls,
            breadcrumbs: [
              {
                title: 'Analytics',
              },
              {
                title: 'Reason For Calls',
              },
            ],
          },
        ],
      },
      {
        type: 'parent',
        path: '/conclusion-of-calls',
        children: [
          {
            type: 'render',
            path: '/',
            component: ConclusionForCalls,
            breadcrumbs: [
              {
                title: 'Analytics',
              },
              {
                title: 'Call Conclusions',
              },
            ],
          },
        ],
      },

      {
        type: 'render',
        path: '/call-resolution',
        component: CallResolution,
        breadcrumbs: [
          {
            title: 'Analytics',
          },
          {
            title: 'Call Resolution',
          },
        ],
      },

      {
        type: 'render',
        path: '/positive-neutral-sentiment',
        component: PositiveSentimentReport,
        breadcrumbs: [
          {
            title: 'Analytics',
          },
          {
            title: 'Positive/Neutral Sentiment',
          },
        ],
      },
      {
        type: 'render',
        path: '/negative-sentiment',
        component: NegativeSentimentReport,
        breadcrumbs: [
          {
            title: 'Analytics',
          },
          {
            title: 'Negative Sentiment',
          },
        ],
      },
    ],
  },
];

const callSettings: AppRoute[] = [
  // number settings
  {
    type: 'parent',
    path: '/channel',
    children: [
      {
        type: 'parent',
        path: '/:channelId',
        children: [
          {
            type: 'render',
            path: '/',
            component: NumberSettingsPage,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
              },
            ],
          },
          {
            type: 'render',
            path: '/business-hours',
            component: BusinessHoursSettingsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Business Hours',
              },
            ],
          },
          {
            type: 'render',
            path: '/after-hours',
            component: AfterHoursSettingsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'After Hours',
              },
            ],
          },
          {
            type: 'render',
            path: '/greeting-message',
            component: GreetingMessagePageV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Greeting Message',
              },
            ],
          },
          {
            type: 'render',
            path: '/ivr',
            component: IVRSettingsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'IVR',
              },
            ],
          },
          {
            type: 'render',
            path: '/call-forwarding',
            component: CallForwardingV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Call Forwarding',
              },
            ],
          },
          {
            type: 'render',
            path: '/voicemail',
            component: VoicemailV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Voicemail',
              },
            ],
          },
          {
            type: 'render',
            path: '/custom-caller-tune',
            component: CustomCallerTuneV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Custom Caller Tune',
              },
            ],
          },
          {
            type: 'render',
            path: '/auto-record',
            component: AutoRecordCallsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Auto Record Calls',
              },
            ],
          },
          {
            type: 'render',
            path: '/email-notification-alert',
            component: EmailNotificationAlertV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Email Notification Alert',
              },
            ],
          },
          {
            type: 'render',
            path: '/call-transfer',
            component: CallTransferV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: ':name',
                link: '/settings/channel/:channelId',
              },
              {
                title: 'Call Transfer Announcements',
              },
            ],
          },
        ],
      },
    ],
  },
  // call settings
  {
    type: 'parent',
    path: '/call-settings',
    children: [
      {
        type: 'render',
        path: '/',
        component: CallFlowsList,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Call Settings',
          },
        ],
      },
      {
        type: 'parent',
        path: '/:callSettingId',
        children: [
          {
            type: 'render',
            path: '/',
            component: CallSettingsPage,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
              },
            ],
          },
          {
            type: 'render',
            path: '/business-hours',
            component: BusinessHoursSettingsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Business Hours',
              },
            ],
          },
          {
            type: 'render',
            path: '/after-hours',
            component: AfterHoursSettingsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'After Hours',
              },
            ],
          },
          {
            type: 'render',
            path: '/greeting-message',
            component: GreetingMessagePageV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Greeting Message',
              },
            ],
          },
          {
            type: 'render',
            path: '/ivr',
            component: IVRSettingsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'IVR',
              },
            ],
          },
          {
            type: 'render',
            path: '/call-forwarding',
            component: CallForwardingV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Call Forwarding',
              },
            ],
          },
          {
            type: 'render',
            path: '/voicemail',
            component: VoicemailV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Voicemail',
              },
            ],
          },
          {
            type: 'render',
            path: '/custom-caller-tune',
            component: CustomCallerTuneV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Custom Caller Tune',
              },
            ],
          },
          {
            type: 'render',
            path: '/auto-record',
            component: AutoRecordCallsV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Auto Record Calls',
              },
            ],
          },
          {
            type: 'render',
            path: '/email-notification-alert',
            component: EmailNotificationAlertV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Email Notification Alert',
              },
            ],
          },
          {
            type: 'render',
            path: '/call-transfer',
            component: CallTransferV2,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Call Settings',
                link: '/settings/call-settings',
              },
              {
                title: ':name',
                link: '/settings/call-settings/:callSettingId',
              },
              {
                title: 'Call Transfer Announcements',
              },
            ],
          },
        ],
      },
    ],
  },
];

export const appPrivateRoutes: AppRoute[] = [
  {
    type: 'render',
    path: '/',
    component: RootRedirect,
  },
  {
    type: 'render',
    path: '/dashboard',
    component: DashboardPage,
    breadcrumbs: [
      {
        title: 'Dashboard',
      },
    ],
  },
  ...analytics,
  {
    type: 'parent',
    path: '/settings',
    children: [
      ...callSettings,
      {
        type: 'parent',
        path: '/my-profile',
        children: [
          {
            type: 'render',
            path: '/',
            component: MyAccountPage,
            rolePrivilege: ROLE_MAPS.SETTINGS_MY_ACCOUNT_DETAIL,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Profile',
              },
            ],
          },
          {
            type: 'render',
            path: '/mfa',
            component: MyMfaPage,
            rolePrivilege: ROLE_MAPS.SETTINGS_MY_ACCOUNT_DETAIL,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Profile',
                link: '/settings/my-profile',
              },
              {
                title: 'Two Factor Authentication',
              },
            ],
          },
          {
            type: 'render',
            path: '/mfa/verify',
            component: MyMfaVerifyPage,
            rolePrivilege: ROLE_MAPS.SETTINGS_MY_ACCOUNT_DETAIL,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Profile',
                link: '/settings/my-profile',
              },
              {
                title: 'Two Factor Authentication',
                link: '/settings/my-profile/mfa',
              },
              {
                title: 'Verify',
              },
            ],
          },
        ],
      },
      {
        type: 'parent',
        path: '/my-numbers',
        children: [
          {
            type: 'render',
            path: '/',
            component: MyNumberSettings,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
              },
            ],
          },
          {
            type: 'render',
            path: '/purchase-number',
            component: PurchaseNumberSettings,
            rolePrivilege: ROLE_MAPS.SETTINGS_MY_NUMBERS_PURCHASE_NUMBER,
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'My Numbers',
                link: '/settings/my-numbers',
              },
              {
                title: 'Purchase Number',
              },
            ],
          },
        ],
      },
      {
        type: 'render',
        path: '/caller-id',
        component: CallerIDSettings,
        rolePrivilege: ROLE_MAPS.SETTINGS_CALLER_ID_LIST,
        planPrivilege: PLAN_MAPS.SETTINGS_CALLER_ID_LIST,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Caller ID',
          },
        ],
      },
      {
        type: 'render',
        path: '/number-groups',
        component: NumberGroups,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Number Groups',
          },
        ],
      },
      {
        type: 'render',
        path: '/members',
        component: MembersSettings,
        rolePrivilege: ROLE_MAPS.SETTINGS_MEMBERS_LIST,
        pageSize: 'medium',
        breadcrumbs: [{ title: 'Settings' }, { title: 'Members' }],
      },
      {
        type: 'parent',
        path: '/team-management',
        children: [
          {
            type: 'render',
            path: '/',
            component: TeamManagementSettings,
            planPrivilege: PLAN_MAPS.TEAMS_TEAMS_LIST,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Teams',
              },
            ],
          },
          {
            type: 'render',
            path: '/:teamId',
            component: TeamDetailSettings,
            planPrivilege: PLAN_MAPS.TEAMS_TEAMS_VIEW,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Teams',
                link: '/settings/team-management',
              },
              {
                title: ':name',
              },
            ],
          },
        ],
      },
      {
        type: 'render',
        path: '/block-list',
        component: BlockListPage,
        rolePrivilege: ROLE_MAPS.SETTINGS_BLOCK_LISTS_LIST,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Block List',
          },
        ],
      },
      {
        type: 'render',
        path: '/saved-replies',
        component: SavedReplies,
        planPrivilege: PLAN_MAPS.SETTINGS_NUMBER_SETTING_VIEW_SAVE_REPLIES,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Saved Replies',
          },
        ],
      },
      {
        type: 'render',
        path: '/subscription',
        component: SubscriptionPage,
        rolePrivilege: ROLE_MAPS.SETTINGS_SUBSCRIPTION_VIEW,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Subscription',
          },
        ],
      },
      {
        type: 'render',
        path: '/payment-methods',
        component: PaymentMethodsPage,
        rolePrivilege: ROLE_MAPS.SETTINGS_PAYMENT_METHOD_VIEW,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Payment Methods',
          },
        ],
      },
      {
        type: 'render',
        path: '/wallet',
        component: Wallet,
        rolePrivilege: ROLE_MAPS.SETTINGS_WALLET_VIEW,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Wallet',
          },
        ],
      },
      {
        type: 'render',
        path: '/order-and-transactions',
        component: OrderAndInvoicesPage,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Order and Transactions',
          },
        ],
      },
      {
        type: 'render',
        path: '/workspace',
        component: WorkspacePage,
        pageSize: 'medium',
        breadcrumbs: [
          {
            title: 'Settings',
          },
          {
            title: 'Workspace',
          },
        ],
      },
      {
        type: 'parent',
        path: '/integrations',
        children: [
          {
            type: 'render',
            path: '/',
            component: Integrations,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Integrations',
              },
            ],
          },
          {
            type: 'render',
            path: '/:id',
            component: IntegrationDetails,
            pageSize: 'medium',
            breadcrumbs: [
              {
                title: 'Settings',
              },
              {
                title: 'Integrations',
                link: '/settings/integrations',
              },
              {
                title: ':name',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: 'parent',
    path: '/conversations',
    children: [
      {
        type: 'parent',
        path: '/:channelId',
        children: [
          {
            type: 'render',
            path: '/:clientId',
            component: ConversationPage,
          },
          {
            type: 'render',
            path: '/',
            component: ConversationRedirection,
          },
          {
            type: 'render',
            path: '/new',
            component: NewConversationPage,
          },
        ],
      },
      {
        type: 'render',
        path: '/member/:memberId',
        component: MemberConversationPage,
      },
    ],
  },
  {
    type: 'parent',
    path: '/bulk-messaging',
    children: [
      {
        type: 'render',
        path: '/',
        breadcrumbs: [
          {
            title: 'Bulk Messaging',
          },
        ],
        component: BulkMessagingPage,
        rolePrivilege: ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_VIEW,
      },
      {
        type: 'render',
        path: '/compose-message',
        component: ComposeMessagePage,
        rolePrivilege: ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_CREATE,
      },
      {
        type: 'render',
        path: '/:campaignId/edit-message',
        component: EditMessagePage,
        rolePrivilege: ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_UPDATE,
      },
      {
        type: 'render',
        path: '/recurring/:campaignId',
        breadcrumbs: [
          {
            title: 'Bulk Messaging',
            link: '/bulk-messaging',
          },
          {
            title: ':name',
          },
        ],
        component: RecurringCampaignPage,
        rolePrivilege: ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_LIST,
      },
      {
        type: 'render',
        path: '/recurring/:campaignId/:runId',
        breadcrumbs: [
          {
            title: 'Bulk Messaging',
            link: '/bulk-messaging',
          },
          {
            title: ':name',
            link: '/bulk-messaging/recurring/:campaignId',
          },
          {
            title: ':runName',
          },
        ],
        component: BulkMessageRunReportPage,
        rolePrivilege: ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_LIST,
      },
      {
        type: 'render',
        path: '/:campaignId',
        breadcrumbs: [
          {
            title: 'Bulk Messaging',
            link: '/bulk-messaging',
          },
          {
            title: ':name',
          },
        ],
        component: BulkMessageReportPage,
        rolePrivilege: ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_LIST,
      },
    ],
  },
  {
    type: 'parent',
    path: '/contacts',
    children: [
      {
        type: 'render',
        path: '/',
        breadcrumbs: [
          {
            title: 'Contacts',
          },
        ],
        component: ContactsPage,
        rolePrivilege: ROLE_MAPS.CONTACTS_CONTACTS_LIST,
      },
      {
        type: 'render',
        path: '/messaging-consents',
        breadcrumbs: [
          {
            title: 'Contacts',
            link: '/contacts',
          },
          {
            title: 'Messaging Consents',
          },
        ],
        component: MessagingConsentPage,
      },
    ],
  },
  {
    type: 'render',
    path: '/support-ticket',
    component: SupportTicket,
  },
  {
    type: 'render',
    path: '/payment-request',
    component: PaymentRequestPage,
  },

  {
    type: 'render',
    path: '*',
    component: RootRedirect,
    breadcrumbs: [{ title: 'Not Found' }],
  },
];

export const basePrivateRoutes: AppRoute[] = [
  {
    type: 'render',
    path: '/app-redirect/:mode',
    component: AppRedirectCenter,
  },
  {
    type: 'render',
    path: '/auth/invitation/:token',
    component: LogoutAndRedirect,
  },
  {
    type: 'render',
    path: '/app/dialer',
    component: DialerPage,
  },
];
